<template>
    <div>
        <div v-if="total_pending > 0" class="bcw bcw__pending_parcels bcw__black">
            <div class="bc__cta">
                <VTooltip :triggers="['click']" placement='top' :distance=10 theme="orphan">
                    <!-- Popover target -->
                    <bcw-button></bcw-button>
                    <!-- Content of popover -->
                    <template #popper>
                        <p class="title">{{ trans('dashboard.orphan.dist') }}</p>
                        <ul>
                            <li v-for="(pe, i) in parcels_per_crop" :key="i">
                                <span :class="'bg--' + pe.logo_name"></span>

                                <p class="crop">{{ pe.crop_name }}</p>
                                <p v-if="pe.subclient" class="subclient" :title="pe.subclient.name">
                                    {{ pe.subclient.name.substring(0, 3) }}...({{ pe.subclient.code }})
                                </p>

                                <data :value="pe.parcels.length">x {{ pe.parcels.length }} </data>
                                <div class="ghost" :class="'ghost--' + pe.logo_name">
                                    <bcw-button :size="16" :href="pe.url" />
                                </div>
                            </li>
                        </ul>

                        <!--
                        <p class="extra">
                            {{ trans('dashboard.orphan.clicking') }}
                            {{ parcels_per_crop[0].crop_name }}
                            {{ trans('dashboard.pending.clicking2') }
                        </p>
                        -->

                    </template>
                </VTooltip>
            </div>
            <p class="subtitle">{{ trans('dashboard.pending.sub') }}</p>


            <p class="title" v-html="trans_choice('dashboard.pending.pending_parcels', total_pending)"></p>


            <img src="images/icon_parcels.svg">
        </div>

        <!-- Zero view -->
        <div v-else class="bcw bcw__pending_parcels">
            <div class="bc__cta">
                <bcw-button></bcw-button>
            </div>
            <p class="subtitle">{{ trans('dashboard.pending.zero.sub') }}</p>
            <p class="title">{{ trans('dashboard.pending.zero.title') }}</p>
            <img src="images/icon_check_bg.svg">
        </div>
    </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'widget',
            'subclients',
        ],


        data(){

            // Get the data from the widget
            let {
                total_pending,
                parcels_per_crop,
            } = this.widget.data();

            // Calculate the url and subclient (for distributors)
            parcels_per_crop = parcels_per_crop.map(crop => {

                let url;
                let subclient = null;
                if(this.subclients){
                    url = `/subclient/switch/${crop.client_id}/${crop.crop_id}?redirect=/parcel_reports`;
                    subclient = this.subclients.filter(sub => sub.id === crop.client_id)[0];
                } else {
                    url = `/crop/switch/${crop.crop_id}?redirect=/parcel_reports`;
                }

                // Return new structure
                return {
                    ...crop,
                    subclient,
                    url,
                }
            });

            // Return the data
            return {
                total_pending,
                parcels_per_crop,
            }


        },


    }

</script>